// DS: DS6.1 - Radio button semantics
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import RadioButton from '../../../../RadioButton';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import commonStyles from '../../common.scss';
import s from './ListItemRadioButton.scss';
const ListItemRadioButton = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { rootProps: { name, value, onChange, checked, controlAlignment = 'top', className }, contentProps, ref } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "name",
        "value",
        "onChange",
        "checked",
        "controlAlignment",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(RadioButton, _object_spread({
        ref: ref,
        className: c(s['root'], controlAlignment === 'center' && s['align-items-center'], className),
        inputClassName: commonStyles['input'],
        name: name || '',
        value: value || '',
        onChange: onChange && (()=>onChange(!checked, value)),
        checked: checked
    }, rest), /*#__PURE__*/ React.createElement(ListItemContent, contentProps));
};
ListItemRadioButton.displayName = 'ListItemRadioButton';
export default ListItemRadioButton;
